import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OperationManagerService {
  private abortController: Subject<void> = new Subject<void>();

  // To show popup / UI disable etc.
  public isOperationRunning: boolean = false;

  startOperation(): Observable<void> {
    // Cancel previous pending API if any
    this.abortOperation();

    // Create fresh Subject for new API
    this.abortController = new Subject<void>();
    this.isOperationRunning = true;
    return this.abortController.asObservable();
  }

  abortOperation(): void {
    if (!this.abortController.closed) {
      this.abortController.next();     // Cancel API requests listening to abort$
      this.abortController.complete();
    }
    this.isOperationRunning = false;
  }

  completeOperation(): void {
    if (!this.abortController.closed) {
      this.abortController.complete();
    }
    this.isOperationRunning = false;
  }

  // Used in takeUntil() to cancel API
  get abort$(): Observable<void> {
    return this.abortController.asObservable();
  }
}
